import React, { useEffect, useMemo, useState } from 'react';
import { useMenuContext } from '../../context';
import { EMenuOpenType } from '../../types';
import Button from './Button';
import Container from './Container';
import { Tooltip } from './Tooltip';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  hasBeenOpened: boolean;
  menuIsOpen: boolean;
};

export default function BMTriggerButton({
  onOpen,
  onClose,
  setMenuIsOpen,
  hasBeenOpened,
  menuIsOpen,
}: Props) {
  const { settings, openType, open, colors, translation } = useMenuContext();

  const [leftOffset, setLeftOffset] = useState(148);
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const tooltipOn = useMemo(
    () => settings.tooltipOnBm && !hasBeenOpened,
    [settings.tooltipOnBm, hasBeenOpened],
  );

  useEffect(() => {
    if (!tooltipOn) return;

    if (tooltipRef.current?.offsetWidth) {
      setLeftOffset(tooltipRef.current?.offsetWidth + 58);
    }
  }, [tooltipOn, tooltipRef.current?.offsetWidth]);

  return (
    <Container hasBeenOpened={hasBeenOpened} tooltipOn={!!tooltipOn} leftOffset={leftOffset}>
      {tooltipOn && (
        <Tooltip
          ref={tooltipRef}
          label={translation?.menuAppointmentTooltip || 'Menu'}
          hasBeenOpened={hasBeenOpened}
          bgColor={colors.bmBg}
          textColor={colors.bmText}
        />
      )}
      <Button
        onOpen={onOpen}
        onClose={onClose}
        active={open ? openType === EMenuOpenType.BM : false}
        setMenuIsOpen={setMenuIsOpen}
        icon="fa-bars"
        menuIsOpen={menuIsOpen}
        hasBeenOpened={hasBeenOpened}
        bgColor={colors.bmBg}
        textColor={colors.bmText}
        openOnHover={settings.openOnHoverBm}
      />
    </Container>
  );
}
